<template lang="pug">
  transition(name='fade')
    .loader(:class='{saved: !isSaving && !error, error: !isSaving && error}' v-if='showLoader')
      .row.middle.center(v-if='isSaving')
        .spinner.m-right-1
        h2.text-normal.bold.dark-gray {{ $t("krea.loaderToast.saving") }}
      .width-100(v-else)
        .row.middle.center(v-show='!error')
          simple-svg.white-icon.m-right-1(:filepath='checkIcon' width='18px' height='18px')
          h2.m4-bottom-05.text-normal.bold.white {{ $t("krea.loaderToast.savedChanges") }}
        .row.middle.center(v-show='error')
          simple-svg.white-icon.m-right-1(:filepath='crossIcon' width='18px' height='18px')
          h2.m4-bottom-05.text-normal.bold.white {{ $t("krea.loaderToast.error") }}
</template>

<script>
import checkIcon from '@/assets/ic_check_base.svg'
import crossIcon from '@/assets/ic_cross.svg'

export default {
  props: {
    isSaving: { type: Boolean, required: true },
    error: { type: Boolean, default: false }
  },
  data() {
    return {
      crossIcon,
      checkIcon,
      showLoader: false
    }
  },
  watch: {
    isSaving(newState) {
      if (newState) {
        this.showLoader = true
      } else {
        setTimeout(() => {
          this.showLoader = false
        }, 3000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';
@import 'src/scss/variables/sizes';

.loader{
  width: 240px;
  z-index: 10;
  position: fixed;
  bottom: 20px;
  right: 0;
  transform: translateX(calc(((100vw - #{$content-size}) / 2) * -1));
  box-shadow: 0px 0px 12px 0px $shadow-gray;
  padding: 15px 20px;
  border-radius: 5px;
  margin: 0;
  transition: all ease-in-out .3s;
  background-color: $white;
  &.saved{
    transition: all ease-in-out .3s;
    background-color: $blue;
  }
  &.error{
    transition: all ease-in-out .3s;
    background-color: $red;
  }
}

.fade-enter-to,
.fade-leave-to {
  opacity: 1;
  transition: opacity .2s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transition: opacity .2s ease-in-out;
}

.spinner{
  width: 12px;
  height: 12px;
  padding: 5px;
  border: 2px solid transparent;
  border-top: 2px solid $dark-gray;
  border-left: 2px solid $dark-gray;
  border-radius: 50%;
  animation: loading 1s linear infinite;
}

@keyframes loading {
  from{
    transform: rotate(0);
  }
  to{
    transform: rotate(360deg);
  }
}
</style>
